import { transformEntityWords } from "../../utils";

export const mapCard = (json) => {
    const { id, name, description, entity, datasetLocale } = json;
    return [
        [{ labels: ["ID"], value: id, type: "string", basis: "5%" }],
        [
            {
                labels: ["Name"],
                value: name,
                type: "string",
                basis: "30%",
            },
        ],
        [
            {
                labels: ["Description"],
                value: description,
                type: "string"
            },
        ],
        [
            {
                labels: ["Dataset Locale"],
                value: datasetLocale,
                type: "string",
                basis: "30%",
            },
        ],
        [
            {
                labels: ["Entity"],
                value: transformEntityWords(entity),
                type: "string",
                basis: "30%",
            },
        ],
        [
            {
                labels: [""],
                value: {
                    id,
                    customComponent: "TranslationTableMoreAction",
                },
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        basis: "5%",
        columnName: "id",
        sortable: true,
    },
    {
        label: ["Name"],
        align: "left",
        basis: "30%",
        columnName: "name",
        sortable: true,
    },
    {
        label: ["Description"],
        align: "left",
        columnName: "description",
        sortable: true,
    }, 
    {
        label: ["Dataset Locale"],
        align: "left",
        columnName: "datasetLocale",
        basis: "30%",
    },
    {
        label: ["Entity"],
        align: "left",
        columnName: "entity",
        basis: "30%",
    },
    { label: ["Actions"], type: "customComponent", align: "right" },
];

const translationtableMapper = {
    map: mapper,
    header,
};

export default translationtableMapper;
